import { SimpleGrid, Stack, useText } from "@sveabank/cc-common";
import { UspListItem } from "../../../components/bullet-list/usp-list-item";
import Hide from "../../../components/hide";
import type { OverDraftPackage } from "../../../types/package";
import PackageBlock from "./package-block";

type Props = {
	overDraftPackage: OverDraftPackage;
};

const OverDraftPackageBlock = ({ overDraftPackage }: Props) => {
	const [t, texts] = useText();
	const text = texts.choosePackage[overDraftPackage.packageId];

	return (
		<PackageBlock
			heading={t(text.title)}
			headingColor="text-text-contrast"
			onboardingPackage={overDraftPackage}
			bgColor="bg-background-dark"
			imageSrc="GROW"
			moreAbout={t(text.moreAbout)}
		>
			<Hide to="tablet">
				<Stack component="ul" gap={4}>
					<SimpleGrid cols={2} gap={1}>
						<UspListItem text={t(text.desktop.bullet1)} />
						<UspListItem text={t(text.desktop.bullet2)} />
						<UspListItem text={t(text.desktop.bullet3)} />
						<UspListItem text={t(text.desktop.bullet4)} />
					</SimpleGrid>
				</Stack>
			</Hide>

			<Hide from="tablet">
				<Stack component="ul" gap={4}>
					<SimpleGrid cols={2} gap={1}>
						<UspListItem text={t(text.mobile.bullet1)} />
						<UspListItem text={t(text.mobile.bullet2)} />
						<UspListItem text={t(text.mobile.bullet3)} />
					</SimpleGrid>
				</Stack>
			</Hide>
		</PackageBlock>
	);
};
export default OverDraftPackageBlock;
